module.exports = __webpack_public_path__ + "assets/ad3c723f20c67a6a81becf7bccadff8a.png";